import { useEffect } from 'react'
import { AreaEnum, MArea } from '@sailor/i18n-web'
import { getIsOrderManager, getRegionByCookie, safeParse } from '@RootCommon/utils'
import { commonRequestAll } from '../utils/request'
import mainApi from '../api/urls'
import { AUTH_MENU_KEY } from '../constants'
import { reportDeviceHeartBeat } from '../utils/omReports/deviceHeartBeat'
import { reportDeviceHeartBeatData, reportDeviceHeartBeatDataBeforeUnload, resetHeartBeatData } from '../utils/omReports/deviceHeartBeatData'
import { reportNetwork } from '../utils/omReports/network'
import { DEVICE_REPORT_TYPE, deviceReport, getDeviceType } from '../api/omReport'
import { startSleepDetection, startNetworkDisconnectDetection } from '../utils/omReports/deviceEventCollector'

// todo：把ls字段统一管理
const PRINT_SETTINGS_STORAGE = 'print_settings'

export async function checkHasTodaysOrderMenu (shopId: number) {
  const { data = {} } = await commonRequestAll.post(mainApi.menuAuthFilter, {
    shopId,
    authKeyList: [AUTH_MENU_KEY.NEWORDER],
  })
  return data?.[AUTH_MENU_KEY.NEWORDER] === 1
}

export default function useHeartbeatReport (shopId: number) {
  const deviceType = getDeviceType()
  const isOrderManager = getIsOrderManager()
  const isBR = getRegionByCookie() === 'BR'
  const isGCC = [...MArea.getRegionsByArea(AreaEnum.GCC)].includes(getRegionByCookie())
  const isSA = getRegionByCookie() === 'SA'

  useEffect(() => {
    // 选门店后才能上报
    if (shopId > 0) {
      if (isOrderManager && isBR) {
        // 如果非BR账号登录OM，不心跳上报
        reportDeviceHeartBeat(deviceType, 1, true) // 设备心跳上报
        resetHeartBeatData() // 重置心跳上报数据
        reportDeviceHeartBeatData(deviceType, true, false) // 设备心跳数据上报
        reportNetwork(deviceType) // 网络上报

        // 启动休眠检测和网络断开检测
        startSleepDetection()
        const cleanupNetworkDisconnectDetection = startNetworkDisconnectDetection()

        // 进入系统后上报打印配置，用于统计打印设置是否完成
        const printSettings = safeParse(localStorage.getItem(PRINT_SETTINGS_STORAGE)) || { autoPrinting: true }
        deviceReport(DEVICE_REPORT_TYPE.PRINTER, {
          printSettingsCompleted: !!(printSettings.printer && printSettings.paperSize && printSettings.printCount),
          printSettings,
        })

        // 页面关闭之前再上报一次心跳数据
        window.addEventListener('beforeunload', reportDeviceHeartBeatDataBeforeUnload)
        return () => {
          // 切换shopId之前再上报一次心跳数据
          reportDeviceHeartBeatData(deviceType, false, true) // 设备心跳数据上报

          // 清理监听器
          cleanupNetworkDisconnectDetection()

          window.removeEventListener('beforeunload', reportDeviceHeartBeatDataBeforeUnload)
        }
      }

      if (!isOrderManager && isGCC && !isSA) {
        checkHasTodaysOrderMenu(shopId).then(hasTodaysOrderMenu => {
          if (hasTodaysOrderMenu) {
            reportDeviceHeartBeat(deviceType, 1, false) // GCC心跳上报不上报数据，因为不支持心跳数据上报接口
          }
        })
      }
    }
  }, [shopId])
}
